<div class="date-range-container">
    <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="rangeGroup" [rangePicker]="picker">
            <input matStartDate formControlName="start" 
                   placeholder="Start date"
                   dateFormat>
            <input matEndDate formControlName="end" 
                   placeholder="End date"
                   dateFormat>
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"
            *ngIf="!disabled">
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-icon-button
            type="button"
            class="date-range-clear"
            aria-label="Clear"
            (click)="clear()"
            [disabled]="(!startControl.value && !endControl.value) ||
                disabled">
        <mat-icon>clear</mat-icon>
    </button>
</div>
